import supabase from "../../../shared/database/supabase";
import { Invoice } from "../model/invoice";

export interface ListInvoicesByServiceOrderResponse {
  invoices: Invoice[];
}

export const listInvoicesByServiceOrder = async (service_order_id: string): Promise<ListInvoicesByServiceOrderResponse> => {
  try {
    const { data, error } = await supabase.functions.invoke("list-invoices-by-service-order", {
      body: JSON.stringify({ serviceOrderId: service_order_id })
    });
    if (error) throw error;

    if (data.error) throw data.error;

    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
